export const PERMISSIONS = {
  ADMIN_VIEW: 'permission-admin-view',
  ADMIN_EDIT: 'permission-admin-edit',
  ADMIN_DELETE: 'permission-admin-delete',
  ADMIN_CREATE: 'permission-admin-create',

  EMPLOYEE_VIEW: 'permission-employee-view',
  EMPLOYEE_EDIT: 'permission-employee-edit',
  EMPLOYEE_DELETE: 'permission-employee-delete',
  EMPLOYEE_CREATE: 'permission-employee-create',
  EMPLOYEE_IMPORT: 'permission-employee-import',

  CONTRACTS_VIEW: 'permission-company-contract-view-assigned',

  
  COMPANY_VIEW: 'permission-company-view',
  COMPANY_EDIT: 'permission-company-edit',
  COMPANY_DELETE: 'permission-company-delete',
  COMPANY_CREATE: 'permission-company-create',
  COMPANY_IMPORT: 'permission-company-import',

  POULE_VIEW: 'permission-pool-view',
  POULE_EDIT: 'permission-pool-edit',
  POULE_DELETE: 'permission-pool-delete',
  POULE_CREATE: 'permission-pool-create',
  POULE_IMPORT: 'permission-pool-import',

  

  ROLE_VIEW: 'permission-role-view',
  ROLE_EDIT: 'permission-role-edit',
  ROLE_DELETE: 'permission-role-delete',
  ROLE_CREATE: 'permission-role-create',

  PRICE_COMPONENT_VIEW: 'permission-price-component-view',
  PRICE_COMPONENT_EDIT: 'permission-price-component-edit',
  PRICE_COMPONENT_DELETE: 'permission-price-component-delete',
  PRICE_COMPONENT_CREATE: 'permission-price-component-create',
  
  PAYSLIPE_VIEW: 'permission-payslipe-view',
  PAYSLIPE_EDIT: 'permission-payslipe-edit',
  PAYSLIPE_DELETE: 'permission-payslipe-delete',
  PAYSLIPE_CREATE: 'permission-payslipe-create',


  CAR_VIEW: 'permission-car-view',
  CAR_EDIT: 'permission-car-edit',
  CAR_DELETE: 'permission-car-delete',
  CAR_CREATE: 'permission-car-create',

  HOUSING_VIEW: 'permission-housing-view',
  HOUSING_EDIT: 'permission-housing-edit',
  HOUSING_DELETE: 'permission-housing-delete',
  HOUSING_CREATE: 'permission-housing-create',

  RESERVATION_VIEW: 'permission-reservation-view',
  RESERVATION_EDIT: 'permission-reservation-edit',
  RESERVATION_DELETE: 'permission-reservation-delete',
  RESERVATION_CREATE: 'permission-reservation-create',

  INVOICES_VIEW: 'permission-invoices-view',
  INVOICES_EDIT: 'permission-invoices-edit',
  INVOICES_DELETE: 'permission-invoices-delete',
  INVOICES_CREATE: 'permission-invoices-create',

  INTERNAL_PAYSLIPE_VIEW: 'permission-internal-payslips-view',
  INTERNAL_PAYSLIPE_EDIT: 'permission-internal-payslips-edit',
  INTERNAL_PAYSLIPE_DELETE: 'permission-internal-payslips-delete',
  INTERNAL_PAYSLIPE_CREATE: 'permission-internal-payslips-create',

  INSURANCE_VIEW: 'permission-insurances-view',
  INSURANCE_EDIT: 'permission-insurances-edit',
  INSURANCE_DELETE: 'permission-insurances-delete',
  INSURANCE_CREATE: 'permission-insurances-create',
  
  LEAVES_VIEW: 'permission-holiday-view',
  LEAVES_EDIT: 'permission-holiday-edit',
  LEAVES_DELETE: 'permission-holiday-delete',
  LEAVES_CREATE: 'permission-holiday-create',

  DEDUCTIONS_VIEW: 'permission-deduction-view',
  DEDUCTIONS_EDIT: 'permission-deduction-edit',
  DEDUCTIONS_DELETE: 'permission-deduction-delete',
  DEDUCTIONS_CREATE: 'permission-deduction-create',

  FINANCE_FEES_CHECKBOX:'permission-finance-fees-checkbox'

}

export const REDIRECT_LINK_PERMISSIONS = {
  'permission-admin-view': '/admins',
  'permission-employee-view': '/employees',
  'permission-company-contract-view-assigned': '/contracts',
  'permission-company-view': '/companies',
  'permission-pool-view': '/pools',
  'permission-role-view': '/roles',
  'permission-price-component-view': '/price-components',
  'permission-payslipe-view': '/payslipes',
  'permission-car-view': '/cars',
  'permission-housing-view': '/housing',
  'permission-reservation-view': '/reservations',
  'permission-invoices-view': '/invoices',
  'permission-internal-payslips-view': '/internal-payslipes',
  'permission-insurances-view': '/insurance',
  'permission-deduction-view': '/deductions',
}
